import { useDispatch, useSelector } from 'react-redux';
import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { RootStoreType } from 'src/types/store';
import Typography from 'src/components/Typography';
import SearchContainer from './SearchContainer';
import AppBarIconsContainer from './AppBarIconsContainer';
import StyledLink from 'src/components/StyledLink';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { pullLocation } from 'src/resources/location/reducer';

const AppBarContainer: FC = () => {
    const dispatch = useDispatch();
    const name = useSelector((state: RootStoreType) => state.location.params.name);
    const backUrl = useSelector((state: RootStoreType) => state.location.params.backUrl);

    return (
        <>
            {backUrl && (
                <StyledLink to={backUrl} onClick={() => dispatch(pullLocation())}>
                    <ArrowBackIosIcon style={{ verticalAlign: 'bottom' }} />
                </StyledLink>
            )}
            <Typography variant="h2">{name}</Typography>
            <Box sx={{ flexGrow: 1 }} />
            {/* <SearchContainer /> */}
            <AppBarIconsContainer />
        </>
    );
};

export default AppBarContainer;
